// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as LegacyIcon from "../../resources/images-and-icons/LegacyIcon.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import Wino_logoPng from "./wino_logo.png";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "color-kMwMTN": "color-xbp64b2",
    "font-kVVagm": "font-xrmhhpu",
    "letterSpacing-kb6lSQ": "letterSpacing-x1owzkzt",
    $$css: "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:19"
  },
  hovered: {
    "color-kMwMTN": "color-x1lewwgq",
    "textDecorationLine-kMnn75": "textDecorationLine-xujl8zx",
    $$css: "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:24"
  }
};
function textStyleProps(hovered) {
  return {
    0: {
      className: "color-xbp64b2 font-xrmhhpu letterSpacing-x1owzkzt",
      "data-style-src": "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:19"
    },
    1: {
      className: "font-xrmhhpu letterSpacing-x1owzkzt color-x1lewwgq textDecorationLine-xujl8zx",
      "data-style-src": "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:19; wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:24"
    }
  }[!!hovered << 0];
}
function iconColorFromHovered(hovered) {
  if (hovered) {
    return "#8a0262";
  } else {
    return "#07061e";
  }
}
function AuthSignupSuccessPage$GettingStartedTextIconLink(props) {
  let match = Hover.use(undefined, undefined, undefined);
  let hovered = match[1];
  let match$1 = textStyleProps(hovered);
  return JsxRuntime.jsx(Navigation.Link.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(LegacyIcon.make, {
          name: "book_bold",
          fill: hovered ? "#8a0262" : "#07061e"
        }), JsxRuntime.jsx("span", {
          children: I18n.t("Getting started guide"),
          className: match$1.className,
          style: match$1.style
        })],
        space: "small"
      }),
      ref: match[0]
    }),
    to: {
      TAG: "Url",
      _0: new URL(HelpCenter.gettingStartedGuideLink)
    },
    openNewTab: true
  });
}
let GettingStartedTextIconLink = {
  styles: styles,
  textStyleProps: textStyleProps,
  iconColorFromHovered: iconColorFromHovered,
  make: AuthSignupSuccessPage$GettingStartedTextIconLink
};
let imageUri = Wino_logoPng;
function AuthSignupSuccessPage$Header(props) {
  return JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx("img", {
          style: {
            height: "40px",
            width: "40px",
            alignSelf: "center"
          },
          src: imageUri
        }), JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("How to contact us? By email at hello@wino.fr"),
          size: "normal"
        })],
        space: "medium"
      })
    }), JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(AuthSignupSuccessPage$GettingStartedTextIconLink, {})
    })],
    align: "spaceBetween"
  });
}
let Header = {
  imageUri: imageUri,
  make: AuthSignupSuccessPage$Header
};
let styles$1 = {
  root: {
    "height-kZKoxP": "height-x5yr21d",
    "maxWidth-ks0D6T": "maxWidth-x18d02x8",
    "paddingBottom-kGO01o": "paddingBottom-xo0ha1f",
    "paddingInline-kg3NbH": "paddingInline-x4l9tsp",
    "paddingTop-kLKAdn": "paddingTop-x1p5oq8j",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:117"
  },
  content: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "height-kZKoxP": "height-xuv0xuj",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginInline-kUOVxO": "marginInline-xvueqy4",
    "maxWidth-ks0D6T": "maxWidth-x1d8734v",
    $$css: "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:125"
  }
};
function styleProps() {
  return {
    className: "height-x5yr21d maxWidth-x18d02x8 paddingBottom-xo0ha1f paddingInline-x4l9tsp paddingTop-x1p5oq8j width-xh8yej3",
    "data-style-src": "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:117"
  };
}
function contentStyleProps() {
  return {
    className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf height-xuv0xuj justifyContent-xl56j7k marginInline-xvueqy4 maxWidth-x1d8734v",
    "data-style-src": "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:125"
  };
}
let textConfirmation = I18n.t("A confirmation email will be sent to you in the next few minutes. Our team will contact you soon to set up the software. You can now close this window.");
function AuthSignupSuccessPage(props) {
  let match = {
    className: "height-x5yr21d maxWidth-x18d02x8 paddingBottom-xo0ha1f paddingInline-x4l9tsp paddingTop-x1p5oq8j width-xh8yej3",
    "data-style-src": "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:117"
  };
  let match$1 = {
    className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf height-xuv0xuj justifyContent-xl56j7k marginInline-xvueqy4 maxWidth-x1d8734v",
    "data-style-src": "wino-gc:src/app/Auth/AuthSignupSuccessPage.res.js:125"
  };
  return JsxRuntime.jsxs("div", {
    children: [JsxRuntime.jsx(AuthSignupSuccessPage$Header, {}), JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(Title.make, {
          children: I18n.t("🎉 Your account has been created successfully!"),
          level: 1,
          align: "center"
        }), JsxRuntime.jsx(TextStyle.make, {
          children: textConfirmation,
          align: "center",
          variation: "normal"
        })],
        space: "normal",
        align: "center"
      }),
      className: match$1.className,
      style: match$1.style
    })],
    className: match.className,
    style: match.style
  });
}
let make = React.memo(AuthSignupSuccessPage);
export { GettingStartedTextIconLink, Header, styles$1 as styles, styleProps, contentStyleProps, textConfirmation, make };
/* styles Not a pure module */